import React from 'react';
import { Drawer } from '@ygtechnologies/rubus-ui';

import { useIsMobile } from '@/utils/hooks';
import type { OptionsFilterFacets } from '../useOptionsData';
import { DeadlineFilter } from './DeadlineFilter';
import { RoomFilter } from './RoomFilter';
import { CategoryFilter } from './CategoryFilter';
import { StatusFilter } from './StatusFilter';
import theme from './FilterSidebar.module.scss';

interface Props {
    facets: OptionsFilterFacets;
    isMobileOpen: boolean;
    onMobileClose: () => void;
}

const FilterCards: React.FC<{ facets: OptionsFilterFacets }> = ({ facets }) => (
    <div className={theme.cards}>
        <DeadlineFilter facets={facets} />
        <RoomFilter facets={facets} />
        <CategoryFilter facets={facets} />
        <StatusFilter />
    </div>
);

export const FilterSidebar: React.FC<Props> = ({ facets, isMobileOpen, onMobileClose }) => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <Drawer
                isOpen={isMobileOpen}
                toggle={onMobileClose}
                position="left"
                size="sm"
                closeOnClickOutside
                closeOnEscape>
                <div className={theme.drawerContent}>
                    <FilterCards facets={facets} />
                </div>
            </Drawer>
        );
    }

    return (
        <div className={theme.desktop}>
            <FilterCards facets={facets} />
        </div>
    );
};
